<template>
<div class="chapter">
<div class="inner_page">
<a id="pFrontCover"></a><a id="pi"></a><a id="pii"></a><a id="piii"></a><a id="piv"></a><a id="pv"></a><a id="pvi"></a>
<div class="copyright">
<p class="left ">Copyright © 1996 by Rick Bass</p>
<div class="timebreak "> </div>
<p class="left ">All rights reserved</p>
<div class="timebreak "> </div>
<p class="left ">
For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<div class="timebreak "> </div>
<p class="left "><a href="http://www.hmhco.com/popular-reading" target="_blank">www.hmhco.com</a></p>
<div class="timebreak "> </div>
<p class="left "><em>The Library of Congress has cataloged the print edition as follows:</em><br/>
Bass, Rick<br/>
The book of Yaak / Rick Bass<br/>
p. cm.<br/>
<span class="smallcaps">ISBN</span> 978-0-395-87746-3 (pbk.)<br/>
1. Nature conservation—Montana—Yaak Valley 2. Nature. 3. Yaak Valley (Mont.). I. Title<br/>
QH76.5.M9B37 1996<br/>
508.786'81—dc2o 96-27270 <span class="smallcaps">CIP</span></p>
<div class="timebreak "> </div>
<p class="left ">e<span class="smallcaps">ISBN</span> 978-0-547-34935-0<br/>
v3.0717</p>
<div class="timebreak "> </div>
<p class="left ">The author is grateful to the Lyndhurst Foundation and to the following magazines, which first published some of these essays in different form: <em>Steelhead, Wild Duck Review, Orion, House Beautiful, AFSEE (Association of Forest Service Employees for Environmental Ethics), Montana Magazine, Audubon, Sierra, Sports Afield, Big Sky Journal, Southern Review, Eugene Weekly, Sonora Review,</em> and the anthologies <em>Best American Nature Writing
1994</em> and <em>Best American Nature Writing 1996.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?0ebc9406